// SearchPage — français. La langue de la console ; le contenu du dossier reste en français lui
// aussi, mais c'est une autre chose : ici ce sont les étiquettes et les verbes.
// 'Search', 'not collected', 'Could not load' et 'Loading…' vivent dans common.fr.ts.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Personal index': 'Index personnel',
  'queries': 'requêtes',
  'results': 'résultats',
  'kept from our own SearXNG and our own snapshots':
    'gardés depuis notre propre SearXNG et nos propres instantanés',

  // la boîte et ses deux verbes
  'A name, an organisation, a question…': 'Un nom, une organisation, une question…',
  'Search the index': 'Chercher dans l’index',
  'Searching…': 'Recherche en cours…',
  'Search live': 'Chercher en direct',
  'Skip the index and ask a provider. This one costs.':
    'Ignorer l’index et interroger un fournisseur. Celle-ci coûte.',

  // le rail
  'Indexed queries': 'Requêtes indexées',
  'distinct questions the index has answered': 'questions distinctes auxquelles l’index a répondu',
  'Results': 'Résultats',
  'across {n} domains': 'sur {n} domaines',
  'From index · 30d': 'Depuis l’index · 30 j',
  'answered without paying a provider': 'répondues sans payer de fournisseur',
  'Live · 30d': 'En direct · 30 j',
  '{n} provider units': '{n} unités fournisseur',
  '{n} unanswered': '{n} sans réponse',
  'Embedded': 'Vectorisés',
  'model unreachable': 'modèle injoignable',
  'the embedding endpoint did not answer': 'le point de terminaison d’embedding n’a pas répondu',
  'nothing has ever been embedded': 'rien n’a jamais été vectorisé',
  'of {n} embeddable results': 'sur {n} résultats vectorisables',

  // d’où vient la réponse
  'answered from the index · no provider was asked':
    'répondu depuis l’index · aucun fournisseur n’a été interrogé',
  'answered from the nearest query the index already held':
    'répondu depuis la requête la plus proche que l’index détenait déjà',
  'answered live by a provider, through the scout':
    'répondu en direct par un fournisseur, via l’éclaireur',
  'no provider answered': 'aucun fournisseur n’a répondu',
  'kept until': 'gardé jusqu’au',

  // la zone des résultats
  'Could not search': 'Recherche impossible',
  'Nothing asked yet. The index answers a repeated question for nothing, a paraphrase from the nearest question it already holds, and anything else through the scout — the one process with egress.':
    'Rien n’a encore été demandé. L’index répond gratuitement à une question répétée, répond à une reformulation depuis la question la plus proche qu’il détient déjà, et passe par l’éclaireur — le seul processus qui sort sur le réseau — pour tout le reste.',
  'No provider answered.': 'Aucun fournisseur n’a répondu.',
  'What follows is the nearest thing the index already holds, not a live answer.':
    'Ce qui suit est ce que l’index détient de plus proche, et non une réponse en direct.',
  'The index holds nothing near this query either, so there is nothing to show.':
    'L’index ne détient rien de proche de cette requête non plus : il n’y a donc rien à montrer.',
  'The provider answered, and answered with nothing.':
    'Le fournisseur a répondu, et il a répondu par rien.',
  'first seen': 'vu la première fois',
  'last seen': 'vu la dernière fois',
  'live': 'en direct',
  'from index': 'depuis l’index',
  'origin: {origin}': 'origine : {origin}',

  // requêtes récentes
  'Recent queries': 'Requêtes récentes',
  'every question anyone asked, and how it was answered':
    'chaque question posée, et la manière dont elle a été répondue',
  'No query has been recorded yet.': 'Aucune requête n’a encore été enregistrée.',
  'Query': 'Requête',
  'Purpose': 'Objet',
  'Answered': 'Répondu',
  'Asked by': 'Demandé par',
  'Cost': 'Coût',
  'When': 'Quand',
  'index': 'index',
  'index_near': 'index (proche)',
  'provider': 'fournisseur',
  'unavailable': 'indisponible',
  'unknown': 'inconnu',
}, 'SearchPage');
